import React, {  Component } from 'react';
import { connect } from 'react-redux'

/* Actions */
import { dropProductSpecsEmail, sendEmailSuccessDialog } from '../../redux/actions';

class EmailSpecOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            param: {
                toEmail: '',
                emailSubject: 'GE Appliances Product Specifications',
                emailMessage: '',
                specURL: ''
            },
            error: {
                toEmailError: '',
                emailSubjectError: ''
            }
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('EmailSpecOverlayDialog', false)

    }
    componentDidMount() {
		// window.scrollTo(0, 0);
		var origin = window.location.origin;
		if(this.props.hideOrigin) origin = "";

        this.setState({
            showDialog: this.props.showDialog,
            param: {
                ...this.state.param,
                specURL: '<a href="'+ origin + this.props.specURL+'">'+ origin + (this.props.specURLLinkText?this.props.specURLLinkText:this.props.specURL) + '</a>',
				emailSubject: this.props.emailSubject?this.props.emailSubject:this.state.param.emailSubject
            }
        });
    }
    handleSendEmail(event) {
        event.preventDefault();
        var self = this;
        if(self.state.param.toEmail !== "" && self.validateEmail(self.state.param.toEmail) && self.state.param.emailSubject !== "") {
            self.props.dropProductSpecsEmail(self.state.param, "emailType=Spec", response => {
                self.props.sendEmailSuccessDialog(true);
            });
            self.props.handleDialog('EmailSpecOverlayDialog', false);
        } else {
            self.setState({
                error: {
                    toEmailError: (this.state.param.toEmail === "" || !self.validateEmail(self.state.param.toEmail))?"error":"",
                    emailSubjectError: this.state.param.emailSubject === "" ?"error":""
                }
            });
        }
    }
    setValue(field, event) {
        this.setState({
            param: {
                ...this.state.param,
                [field]: event.target.value
            },
            error: {
                ...this.state.error,
                [field+"Error"]: event.target.value === ""?"error":""
            }
        });
    }
    validateEmail(emails) {
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
        emails = emails.split(',');
        for (var i = 0; i < emails.length; i++) {
            if(emails[i].trim() !== "" && !emails[i].trim().match(re)) {
                return false;
            }
        }
        return true;
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="emailSpecOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Email Product Specifications</h2>
                    <p>Fill out the information below.</p>
                    <form className="emailSpecForm" onSubmit={this.handleSendEmail.bind(this)}>
                        <table className="formTableTypeA emailSpecFormTable">
                            <tbody>
                                <tr>
                                    <td> Send to Email Address: </td>
                                    <td>
                                    <input type="text" className={this.state.error.toEmailError} name="emailAddresses" onChange={this.setValue.bind(this, "toEmail")} />
                                        <div className="small">Separate multiple email addresses by commas.<br />(e.g., johndoe@geappliances.com,janedoe@geappliances.com)</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td> Subject Line of Email </td>
                                    <td>
                                        <input type="text" className={this.state.error.emailSubjectError} name="subject" onChange={this.setValue.bind(this, "emailSubject")} value={this.state.param.emailSubject} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Your Message:</td>
                                    <td style={{verticalAlign: 'top'}}>
                                        <textarea name="message" maxLength={300} onChange={this.setValue.bind(this, "emailMessage")} defaultValue={""} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p>Privacy is important to us. The email addresses entered above will not be stored for future use and will be deleted after the email has been sent.</p>
                        <div className="floatLeft">
                            <input className="blueButton" type="reset" value="Clear Form" />
                        </div>
                        <div className="floatRight">
                            <input className="blueButton" type="submit" value="Send" />
                        </div>
                        <div className="clear" />
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
    sendEmailSuccessDialog: (emailSendSuccessDialog) => dispatch(sendEmailSuccessDialog(emailSendSuccessDialog))
});

EmailSpecOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(EmailSpecOverlayDialog);
export default EmailSpecOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/emailSpecOverlayDialog.js